module.exports = __webpack_public_path__ + "img/instagram.60141056.svg";